'use strict';

(function (snapOnline, $) {
    // Called when then Dynamic Dialog Window loads new content or finishes the 'open' animation;
    // we use it to ensure any autofocus element receives focus.
    function applyAutofocusToDynamicDialogContent() {
        var autofocusTarget = $('#dynamicDialogWindow').find('input[autofocus]').first();
        if (autofocusTarget) {
            autofocusTarget.focus();
            if (autofocusTarget.data('auto-select-text')) {
                autofocusTarget.select();
            }
        }
    }

    // Updates the layout of the Dynamic Dialog window to ensure that the outer padding (provided by
    // Kendo) is removed if the content is placed within our own padded container.
    function updateDynamicDialogLayout() {
        var dialog = $('#dynamicDialogWindow');
        var scroller = dialog.find('.modal-dialog-content-scroller');
        var content = dialog.find('.modal-dialog-content');
        if (content.length) {
            dialog.css('padding', '0');
        }
        if (scroller.length) {
            scroller.css('max-height', window.innerHeight - 270);
        }
    }

    // Sets the content of the Dynamic Dialog Window, updates its layout, then opens the window.
    function setDynamicDialogContentAndOpen(dialog, content) {
        dialog.content(content);
        updateDynamicDialogLayout();
        dialog.open();
    }

    // Closes and destroys the Kendo Window created by createDynamicDialogWindow().
    function closeDynamicDialogWindow() {
        var windowObject = $('#dynamicDialogWindow').data('kendoWindow');
        if (windowObject) {
            windowObject.close();
        }
    }

    // Ensure required nested namespaces are declared.
    snapOnline.Dialogs = snapOnline.Dialogs || {};

    // ----- Public interface from here -----

    snapOnline.Dialogs.changeDynamicDialogWindowTitle = function (title) {
        var windowObject = $('#dynamicDialogWindow').data('kendoWindow');
        if (windowObject) {
            windowObject.setOptions({
                title: title
            });
        }

        return;
    };

    // Ensures the Dynamic Dialog Window fits within the screen nicely, and that the first input is focused.
    snapOnline.Dialogs.onDynamicDialogContentRefreshed = function () {
        updateDynamicDialogLayout();
        applyAutofocusToDynamicDialogContent();
    };

    // Fills the specified dialog with a 'wait spinner'.
    // The 'dialogWindow' parameter should be a Kendo window.
    snapOnline.Dialogs.addWaitSpinnerToDialog = function (dialogWindow) {
        dialogWindow.content('<div class="sol-row"><div class="col-12 centered">' + snapOnline.getWaitSpinnerImage() + '</div></div>');
    };

    // Opens the Qwizard Window, loading content from the specified URL.
    snapOnline.Dialogs.openQwizardWindow = function (title, contentUrl, closeActionUrl) {
        var windowObject = $('#qwizardWindow').data('kendoWindow');
        windowObject.setOptions({
            title: title,
            modal: true,
            draggable: false,
            width: '85%',
            height: '85%',
            close: function () { snapOnline.Dialogs.onQwizardWindowClosed(closeActionUrl); }
        });
        windowObject.content('');
        kendo.ui.progress(windowObject.element, true);
        windowObject.refresh(contentUrl);
        windowObject.center();
        windowObject.open();
    };

    snapOnline.Dialogs.onQwizardWindowClosed = function (closeActionUrl) {
        $.get(closeActionUrl);
    };


    // Closes the common Kendo Dialog Window that is created and used from the server-rendered pages.
    snapOnline.Dialogs.closeSharedDialogWindow = function () {
        var windowObject = $('#dialogWindow').data('kendoWindow');
        if (windowObject) {
            windowObject.close();
        }
    };

    // Creates a Kendo Window that is horizontally-centered, placed near the top of the screen, and that resizes vertically to neatly fit its contents.
    snapOnline.Dialogs.createDynamicDialogWindow = function (width, title, offset) {
        var dialogWindow = $('#dynamicDialogWindow').data('kendoWindow');
        if (!dialogWindow) {
            $('<div/>', { id: 'dynamicDialogWindow' }).kendoWindow({});
            dialogWindow = $('#dynamicDialogWindow').data('kendoWindow');
        }

        dialogWindow.setOptions({
            modal: true,
            iframe: false,
            draggable: false,
            scrollable: true,
            resizable: false,
            pinned: false,
            actions: ['Close'],
            title: title,
            width: width,
            height: null,
            position: {
                top: ((offset) ? 130 : 100),
                left: (window.innerWidth - width) / 2
            },
            refresh: snapOnline.Dialogs.onDynamicDialogContentRefreshed,
            activate: applyAutofocusToDynamicDialogContent,
            deactivate: function () {
                $('#dynamicDialogWindow').data('kendoWindow').destroy();
            }
        });

        snapOnline.Dialogs.addWaitSpinnerToDialog(dialogWindow);
        return dialogWindow;
    };

    //Login window functions
    snapOnline.Dialogs.createDynamicLogInDialogWindow = function (width, title) {
        var dialogWindow = $('#dynamicLogInDialogWindow').data('kendoWindow');
        if (!dialogWindow) {
            $('<div/>', { id: 'dynamicLogInDialogWindow' }).kendoWindow({});
            dialogWindow = $('#dynamicLogInDialogWindow').data('kendoWindow');
        }

        dialogWindow.setOptions({
            modal: true,
            iframe: false,
            draggable: false,
            scrollable: true,
            resizable: false,
            pinned: false,
            actions: [],
            title: title,
            width: width,
            height: null,
            position: {
                top: 100,
                left: (window.innerWidth - width) / 2
            },
            refresh: snapOnline.Dialogs.onDynamicLogInDialogContentRefreshed,
            activate: applyAutofocusToDynamicLogInDialogContent,
            deactivate: function () {
                //$('#dynamicLogInDialogWindow').data('kendoWindow').destroy();
                //Leave it there for the next time. It will disappear but it won't be destroyed.
            }
        });

        snapOnline.Dialogs.addWaitSpinnerToDialog(dialogWindow);
        return dialogWindow;
    };

    snapOnline.Dialogs.closeDynamicLogInDialogWindow = function () {
        var windowObject = $('#dynamicLogInDialogWindow').data('kendoWindow');
        if (windowObject) {
            windowObject.close();
        }
    };

    snapOnline.Dialogs.onDynamicLogInDialogContentRefreshed = function () {
        updateDynamicLogInDialogLayout();
        applyAutofocusToDynamicLogInDialogContent();
    };

    function updateDynamicLogInDialogLayout() {
        var dialog = $('#dynamicLogInDialogWindow');
        var scroller = dialog.find('.modal-dialog-content-scroller');
        var content = dialog.find('.modal-dialog-content');
        if (content.length) {
            dialog.css('padding', '0');
        }
        if (scroller.length) {
            scroller.css('max-height', window.innerHeight - 270);
        }
    }

    function applyAutofocusToDynamicLogInDialogContent() {
        var autofocusTarget = $('#dynamicLogInDialogWindow').find('input[autofocus]').first();
        if (autofocusTarget) {
            autofocusTarget.focus();
            if (autofocusTarget.data('auto-select-text')) {
                autofocusTarget.select();
            }
        }
    }

    snapOnline.Dialogs.changeDynamicDialogLogInWindowTitle = function (title) {
        var windowObject = $('#dynamicLogInDialogWindow').data('kendoWindow');
        if (windowObject) {
            windowObject.setOptions({
                title: title
            });
        }

        return;
    };
    //END Login window functions

    // Closes and destroys the Kendo Window created by createDynamicDialogWindow().
    snapOnline.Dialogs.closeDynamicDialogWindow = closeDynamicDialogWindow;

    // Immediately closes the Dynamic Dialog Window, if it exists (without a closing animation).
    snapOnline.Dialogs.immediatelyDestroyDynamicDialogWindow = function () {
        var dialogWindow = $('#dynamicDialogWindow').data('kendoWindow');
        if (dialogWindow) {
            dialogWindow.destroy();
        }
    };

    // Closes and destroys a custom client-side dialog created by one of the functions below.
    snapOnline.Dialogs.closeCustomDialog = function (dialogSelector) {
        dialogSelector.data('kendoDialog').close().destroy();
        dialogSelector.remove();
    };

    // Shows an informational message.
    snapOnline.Dialogs.messageDialog = function (text, title) {
        var messageAndButton = $('<div class="modal-dialog-content"></div>')
            .append($('<div class="sol-row"></div>').append($('<div class="col-12"></div>').html(text)))
            .append($('<div class="sol-row"></div>').append($('<div class="col-12 right"></div>')
                .append($('<button class="sol-button on-white"></button>').click(closeDynamicDialogWindow).append('<span class="fms-icon icon-check"></span>OK')))
            );

        var dialog = snapOnline.Dialogs.createDynamicDialogWindow(350, title || 'Message');
        setDynamicDialogContentAndOpen(dialog, messageAndButton);
    };

    // Shows a confirmation dialog, with OK and Cancel buttons.
    // Returns a Promise that resolves if the user clicks OK, otherwise rejects.
    snapOnline.Dialogs.confirmDialog = function (question, title) {
        return new Promise(function (resolve, reject) {
            var message = $('<div class="modal-dialog-content"></div>').append($('<div class="sol-row"></div>').append($('<div class="col-12"></div>').html(question)));
            var buttons = $('<div class="modal-dialog-buttons"></div>');
            buttons.append($('<div/>').append($('<button class="sol-button"></button>').click(function () {
                closeDynamicDialogWindow();
                reject();
            }).append('<span class="fms-icon icon-cancel"></span>Cancel')));
            buttons.append($('<div/>').append($('<button class="sol-button"></button>').click(function () {
                closeDynamicDialogWindow();
                resolve(true);
            }).append('<span class="fms-icon icon-check"></span>OK')));

            var dialogWindow = snapOnline.Dialogs.createDynamicDialogWindow(400, title);
            dialogWindow.setOptions({
                actions: []
            });
            setDynamicDialogContentAndOpen(dialogWindow, $('<div/>').append([message, buttons]));
        });
    };

    // Creates a new client-side Wait Dialog, and returns its selector.
    snapOnline.Dialogs.waitDialog = function (text, title) {
        var waitImgUrl = snapOnline.getSolBaseUrl() + '/Content/Images/smallspinner.gif';
        var dialogSelector = $('<div/>');
        dialogSelector.kendoDialog({
            closable: false,
            modal: true,
            width: 400,
            title: title || 'Please wait',
            content: '<p style="text-align: center;">' + text + '</p><div><img style="display: block; margin: 0 auto;" src="' + waitImgUrl + '"></div>',
            actions: []
        });
        dialogSelector.data('kendoDialog').open();
        return dialogSelector;
    };

    // Launches a dialog that will indicate a data export is in-progress, prior to download.
    // The data might be response data, a Snap Database Link output, or Participants export.
    snapOnline.Dialogs.createDownloadDialog = function (url) {
        var windowObject = snapOnline.Dialogs.createDynamicDialogWindow(500, 'Preparing download...');
        windowObject.refresh(url);
        windowObject.open();
    };

    snapOnline.Dialogs.createInlineAnalysisDialog = function (url, onrefresh) {
        var windowObject = snapOnline.Dialogs.createDynamicDialogWindow(500, 'Run Report');
        windowObject.setOptions({
            height: 400,
            refresh: onrefresh
        });
        windowObject.refresh(url);
        windowObject.open();
    };

    //Specific to downloading responses as the format is obtained from a hiddn field that is held in the selctedFormatId dom element
    snapOnline.Dialogs.createResponseDownloadDialog = function (url) {
        var exportFormatid = $('input[id=selectedFormatId]').val();
        url = url + '&formatId=' + parseInt(exportFormatid);

        var batchSelect = $('select[id=batchOptions]');
        if (batchSelect.length) {
            url = url + '&batchStart=' + parseInt(batchSelect.val());
        }
        else {
            url = url + '&batchStart=0';
        }

        var userFilterBox = $('input[id=userFilter]');
        if (userFilterBox.length) {
            var encodedValue = encodeURIComponent(userFilterBox.val()).replace('+', '%20');
            url = url + '&userFilter=' + encodedValue;
        }
        else {
            url = url + '&userFilter=';
        }

        var snapExportOptionFlag = 0;
        snapExportOptionFlag = snapOnline.ResponsesPage.getExportOptionFlags();
        url = url + '&exportOptions=' + snapExportOptionFlag;

        snapOnline.Dialogs.createDownloadDialog(url);
    };

    // Called from ExportDownload.cshtml; it initiates the download, then watches for a cookie (set by the arrival of the download),
    // and closes the pop-up dialog when this cookie is found.
    snapOnline.Dialogs.onDownloadReady = function (cookieName) {
        $('#dynamicDialogWindow').data('kendoWindow').setOptions({ title: 'Download ready' });
        snapOnline.waitForCookie(cookieName).then(function () {
            snapOnline.Dialogs.closeDynamicDialogWindow();
            document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'; // Remove the cookie.
        }, snapOnline.noop);
        $('#auto-download-link')[0].click();
    };

    // Launch dialog to upload a file for an import Database Link.
    snapOnline.Dialogs.launchImportDialog = function (title, url) {
        var windowObject = snapOnline.Dialogs.createDynamicDialogWindow(500, title);
        windowObject.refresh(url);
        windowObject.open();
    };

    snapOnline.Dialogs.launchUndeleteDialog = function (title, url) {
        var windowObject = snapOnline.Dialogs.createDynamicDialogWindow(800, title);
        windowObject.refresh(url);
        windowObject.open();
    };


    // Shows an error message, either in the existing dynamic dialog window, or in a new dialog.
    snapOnline.Dialogs.showErrorMessage = function (message, forceClose) {
        var dialogSelector = $('#dynamicDialogWindow');
        var destroyed = false;
        if (forceClose) {//if we have just run a confirm prompt, then the previous dialog may still be animating closed... get rid of it
            var windowObject = dialogSelector.data('kendoWindow');
            if (windowObject) {
                windowObject.destroy();
                destroyed = true;
            }
        }
        var iconAndMessage = '<div class="sol-row"><div class="col-12"><div style="display:flex;"><span class="fms-icon icon-error"></span>&nbsp;<span>' + message + '</span></div></div></div>';
        if (dialogSelector.length && !destroyed) {
            dialogSelector.data('kendoWindow').content(iconAndMessage);
            updateDynamicDialogLayout();
        } else {
            var dialog = snapOnline.Dialogs.createDynamicDialogWindow(400, 'Error');
            setDynamicDialogContentAndOpen(dialog, iconAndMessage);
        }
    };

    // Called when a button is clicked in a suitable dialog.
    // Hide buttons and show wait-spinner.
    snapOnline.Dialogs.showDialogSpinner = function () {
        $('#snapDialogButtons').addClass('hide');
        $('#snapDialogSpinner').removeClass('hide');
    };

}(window.SnapOnline = window.SnapOnline || {}, jQuery));
